import React, { Component } from "react"
import exposeGlobal from "apis/expose-global"
import { fetchKoalaData } from "apis/koala"
import { get } from "utils/object"
import { flashActionTypes } from "../../store/actions/mymazda"

/** Base form class to handle field interaction & validation  */
export default class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: {},
      submitting: false,
      error: null,
      errorMessages: [],
      displayThankYou: false
    }
    this.fieldRefs = {}
  }

  componentDidMount() {
    exposeGlobal("getCurrentFormFields", () => this.state.fields)
  }

  assignFields = (newObject) => {
    const fields = Object.assign(this.state.fields, newObject)
    return { fields }
  }
  updateField = (id, getData) => {
    const field = this.state.fields[id]
    this.setField({
      [id]: {
        ...field,
        ...getData(field)
      }
    })
  }
  setField = (newObject, callback) => {
    /**
   * Sets state for single field
   * @param {Object} [newObject] - Object containing new field state
   * @param {Function} [callback] - Callback on state updated
   */
    this.setState({ ...this.assignFields(newObject), error: null, errorMessages: [] }, callback)
  }
  /**
   * Links field changes to form state
   * @param {String} [name] - Unique name for field. Used in state.
   * @param {Function} [validation] - A validation function apply to field.
   * @returns {Object} - Props for fields.
   */
  linkState = (name, validation = () => ({ isValid: true })) => {
    const validate = (inputValue, validate, context) => {
      const result = validation(inputValue, context || {})
      const attributes = get("attributes", result) ? result.attributes : {}
      const status = validate || (result.status && result.status.isValid) ? (get("status", result) ? result.status : result) : {}
      const value =
        typeof status.modifiedValue !== "undefined" ? status.modifiedValue : inputValue || undefined
      return { status, attributes, value }
    }
    const { fields } = this.state
    if (!fields[name]) {
      const { prefillFields = {} } = this.props
      let field = validate(false, true)
      if (prefillFields[name]) {
        field = validate(prefillFields[name], true, { onBlur: true })
        field.edited = true
        /*
          Hack ALERT!! setting state in render is BAD
          This will set state for defaults then break out of render
        */
        this.setField({
          [name]: {
            ...fields[name],
            ...field
          }
        })
        return null
      }
      field.status = !field.attributes.required ? field.status : {}
      fields[name] = field
    }
    const { status, value, attributes = {} } = fields[name]
    const { required, maxLength } = attributes
    const { isValid, message, modifiedValue } = status
    return {
      name,
      required,
      isValid,
      message,
      id: name,
      maxLength,
      ref: (element) => {
        this.fieldRefs[name] = element
      },
      focus: fields[name].focused,
      value: typeof modifiedValue !== "undefined" ? modifiedValue : value,
      onFocus: () => {
        this.setField({
          [name]: {
            ...fields[name],
            ...validate(fields[name].value, fields[name].dirty, {
              onFocus: true
            }),
            focused: true
          }
        })
        Object.keys(fields).forEach((field) => {
          if (field !== name && fields[field].focused) {
            this.setField({
              [field]: {
                ...fields[field],
                focused: false
              }
            })
          }
        })
      },
      onBlur: () => {
        this.setField({
          [name]: {
            ...fields[name],
            ...validate(
              fields[name].value,
              fields[name].dirty || fields[name].focused !== "undefined",
              { onBlur: true }
            ),
            edited: fields[name].focused !== "undefined",
            focused: false
          }
        })
      },
      onChange: (x) => {
        const value = x && x.target ? get("target.value", x) || "" : x || x === 0 ? x : ""
        this.setField({
          [name]: {
            ...fields[name],
            ...validate(value, fields[name].edited || !fields[name].focused, {
              onChange: true
            }),
            edited: fields[name].edited || !fields[name].focused,
            dirty: true
          }
        })
      }
    }
  }

  canSubmit() {
    /**
     * Checks validity of all fields in state
     * @returns {Boolean} - true if all fields are valid
     */
    const { fields } = this.state
    const formIsValid = Object.keys(fields).every((key) => {
      const field = fields[key]
      if (field.attributes && field.attributes.required) {
        if (!field.value || !field.status.isValid) {
          return false
        }
      }
      if (field.value && field.status && !field.status.isValid) {
        return false
      }
      return true
    })
    return !this.state.submitting && formIsValid
  }

  submit(endpoint, data, mapping, additionalOptions, submitFunc = fetchKoalaData) {
    /**
     * Submits form to endpoint
     * @param {String} [endpoint] - Url for endpoint submission.
     * @param {Object} [data] - Field data to submit.
     * @param {Function} [mapping] - Mapping from field data in state to endpoint body object.
     */
    if (!endpoint || !data || !mapping) return Promise.resolve()

    // Show Warnings or Errors on all required inputs
    if (!this.canSubmit()){
      Object.keys(this.fieldRefs).map((item)=>{
        if (
          this.fieldRefs[item]
          && this.fieldRefs[item].props
          && this.fieldRefs[item].props.required
        ){
          this.fieldRefs[item].props.onBlur()
        }
      })
      return Promise.resolve()
    }

    let payload
    try {
      payload = mapping(data)
    } catch (error) {
      console.warn(error)
      return Promise.reject()
    }
    this.setState({ submitting: true, error: null, errorMessages: [] })
    return submitFunc(endpoint, payload, additionalOptions)
      .then((data) => {
        this.setState({
          data,
          error: null,
          errorMessages: [],
          submitting: false,
          displayThankYou: true
        })
        return { success: true }
      })
      .catch((error) => {
        if (this.fieldRefs.captcha) {
          this.fieldRefs.captcha.reset()
          this.setField({
            captcha: {
              attributes: {
                required: true
              },
              status: {
                isValid: true
              },
              value: ""
            }
          })
        }
        this.setState({
          error: error.message || null,
          errorMessages: error.data || [],
          words: (error.words && error.words.split(",")) || [],
          submitting: false
        })
        return { error: true }
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/index.jsx